/** Shared copy for guest album promo (modal + page banner). */
export type LatestUpdatePromoSurface = 'login' | 'home' | null

export const LATEST_UPDATE_PROMO_PATH = '/guest-album'

export const LATEST_UPDATE_PROMO_HEADLINE = 'Share your photos!'

export const LATEST_UPDATE_PROMO_BODY =
  'We\'d love to see the day through your eyes. Add your photos and videos to our shared Google Photos album.'

export const LATEST_UPDATE_PROMO_CTA = 'Open shared album'

export const GUEST_ALBUM_URL = 'https://photos.app.goo.gl/jM1LxggsnUVGDzA19'
